import { useSearchParams } from 'next/navigation'
import { useEffect, useMemo } from 'react'
import { useUser } from '@/domain/user/hooks'

export type BookingQueryParam = 'bookingNumber' | 'groupUserId'

export function useAccountBookingQueryParam(queryParam: BookingQueryParam) {
  const searchParams = useSearchParams()
  return useMemo(() => searchParams.get(queryParam) ?? '', [searchParams, queryParam])
}

interface UseAuthProtectionOptions {
  redirectTo?: string
  windowObj?: Pick<Window, 'location'>
}

export function useAuthProtection({
  redirectTo = '/',
  windowObj,
}: UseAuthProtectionOptions = {}) {
  const { isLoggedIn, isLoading, isFetching } = useUser()

  useEffect(() => {
    if (!isLoading && !isLoggedIn) {
      const win = windowObj ?? window
      win.location.replace(redirectTo)
    }
  }, [isLoggedIn, isLoading, redirectTo, windowObj])

  return {
    isAuthenticated: !isLoading && !isFetching && isLoggedIn,
    isLoggedIn,
    isLoading,
    isProtected: !isLoggedIn,
  }
}
